/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { Modal } from 'antd-mobile'
import { Button, CloseBtn } from '@styles/button.style'
import { LightListDetailPopupWrap, ModalBg } from '@styles/base.style'
import { isMobile } from 'react-device-detect'
import { NOTICE_CATEGORY } from '@v2/constants/common'
import dayjs from 'dayjs'

const NoticeDetail: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleNoticeDetail } = globalStore
  const { noticeDetail = { category: '', title: '', content: '', createdAt: '', thumbnailUrl: null } } = componentStore
  const { category, title, content, createdAt, thumbnailUrl } = noticeDetail

  const closeNoticeDetailPopup = () => {
    globalStore.setVisibleNoticeDetail(false)
  }


  const closeButtonClickHandler = async () => {
    closeNoticeDetailPopup()
  }

  let thumbnail

  if (category !== NOTICE_CATEGORY.TIP
  && thumbnailUrl) {
    thumbnail = (
      <div className="list-contents">
        <img className="thumbnail" src={thumbnailUrl} alt="첨부 이미지"/>
      </div>
    )
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleNoticeDetail}
        animated={false}
        title={
          <Fragment>
            <h1 className="title">상세내용</h1>
            <Button onClick={closeButtonClickHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal"
        onClose={closeButtonClickHandler}
      >
        <LightListDetailPopupWrap className={!isMobile && 'pc'}>
          <Fragment>
            <div className="list-info">
              <p className="tit line-2">{title}</p>
              <p className="date">{dayjs(createdAt).format('YYYY.MM.DD')}</p>
            </div>
            <div className="list-contents" dangerouslySetInnerHTML={{ __html: content }}/>
            {thumbnail}
          </Fragment>
        </LightListDetailPopupWrap>
        {!isMobile && <ModalBg onClick={closeButtonClickHandler}/>}
      </Modal>
    </Fragment>
  )
}
export default observer(NoticeDetail)
